import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IDSAuthService } from 'src/app/services/idsauth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  isLoading = true;
  loadingMessage = 'Checking your session...';
  showManualLogin = false;
  errorMessage = '';
  logoPath = environment.appLogoPath;

  constructor(
    private idsauthService: IDSAuthService,
    private router: Router
  ) {
  }
  ngOnInit(): void {
    console.log('LoginComponent initialized');
    // If a valid token already exists in storage, go straight to the app
    // without triggering a full OIDC redirect to the IDS server
    if (this.idsauthService.isAuthenticated()) {
      console.log('Token found, navigating to home.');
      this.router.navigateByUrl('/');
      return;
    }
    console.log('Login required, initiating login process.');
    this.idsauthService.login({});
  }
}